import React from 'react'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import MuiDialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import ShareIcon from '@mui/icons-material/Share'
import Typography from '@mui/material/Typography'
import parse from 'html-react-parser'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Button, DialogActions } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
  },
}))

interface DialogTitleProps {
  children: React.ReactNode
  onClose: () => void
  onShare?: () => void
}

const DialogTitle = (props: DialogTitleProps) => {
  const classes = useStyles()
  const { children, onClose, onShare, ...other } = props
  return (
    <MuiDialogTitle className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      <div>
        {onShare && (
          <IconButton aria-label="share" onClick={onShare} size="large">
            <ShareIcon />
          </IconButton>
        )}
        <IconButton aria-label="close" onClick={onClose} size="large">
          <CloseIcon />
        </IconButton>
      </div>
    </MuiDialogTitle>
  )
}

interface Action {
  fn: () => void
  text: string
}

interface Props {
  isOpen: boolean
  handleClose: () => void
  handleShare?: () => void
  content?: string
  title?: string
  width?: DialogProps['maxWidth']
  actions?: {
    confirm?: Action
    third?: Action
  }
  mobileFullScreen?: boolean
  children?: React.ReactNode
}

export default function Modal({
  isOpen,
  handleClose,
  handleShare,
  content,
  title,
  actions,
  width = 'lg',
  mobileFullScreen = false,
  children,
}: Props) {
  const isMobileView = useMediaQuery('(max-width:600px)')
  return (
    <Dialog
      fullScreen={mobileFullScreen && isMobileView}
      maxWidth={width}
      onClose={handleClose}
      open={isOpen}
    >
      <DialogTitle onClose={handleClose} onShare={handleShare}>
        {title}
      </DialogTitle>

      {content && <DialogContent>{parse(content)}</DialogContent>}
      {children && <DialogContent>{children}</DialogContent>}

      {actions && (
        <DialogActions>
          {actions.third && (
            <Button onClick={actions.third.fn} color="primary" autoFocus>
              {actions.third.text}
            </Button>
          )}
          {actions.confirm && (
            <Button onClick={actions.confirm.fn} color="primary" autoFocus>
              {actions.confirm.text}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  )
}
